import { css } from '@emotion/react'
import * as React from 'react'
import Helmet from './PageHelmet'
import { Link } from 'react-router-dom'

type RecordKind = 'event' | 'story' | 'place'

const linkStyle = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 25px;
  margin-bottom: 10px;
  border-bottom: 1px solid #aaa;
`

const RecordMessage: React.FC<{ title: string; heading: string; text?: string; backTo?: string; backLabel?: string }> = ({
  title,
  heading,
  text,
  backTo,
  backLabel,
}) => (
  <section
    className="record-not-found"
    css={css`
      padding: 20px;
    `}
  >
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {backTo && (
      <Link to={backTo} css={linkStyle}>
        <span style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>←</span>
        <span>{backLabel}</span>
      </Link>
    )}
    <h1>{heading}</h1>
    {text && <p>{text}</p>}
  </section>
)

// Shown in place of a story, place or edit page when the address matches nothing the visitor may see.
export const RecordNotFound: React.FC<{ kind: RecordKind; backTo?: string; backLabel?: string }> = ({ kind, backTo, backLabel }) => (
  <RecordMessage
    title={`${kind.charAt(0).toUpperCase()}${kind.slice(1)} not found`}
    heading={`We couldn't find that ${kind}`}
    text="It may have been removed, or the address may be mistyped."
    backTo={backTo}
    backLabel={backLabel}
  />
)

// Shown when the connection or the server failed, so the record may well exist (CVL-138).
export const RecordLoadFailed: React.FC = () => <RecordMessage title="Something went wrong" heading="Something went wrong. Please try again." />
